import {Component, OnDestroy, ViewChild} from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'app/common/services/auth.service';
import { isClubRole } from 'app/common/models/user-info.model';
import { PersistenceService } from 'app/common/services/persistence.service';
import { ApiV2Service } from 'app/common/services/api-v2.service';
import { NgForm, NgModel } from '@angular/forms';

export class User {
  name: string;
  pass: string;
  code: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy {

  @ViewChild('pass') pass: NgModel;
  @ViewChild('name') name: NgModel;
  @ViewChild('code') code: NgModel;
  @ViewChild('form') form: NgForm;

  public _mode: 'pswd' | 'code' = 'code';
  private isCodeRequested = false;
  public get _isAuthStep() { return this._mode == 'pswd' || this.isCodeRequested; }

  public isSubmit: boolean;
  public attemptToSend = false;
  private authToken: string;
  user: User = new User();

  // Переменные для блокировки кнопки "Получить код повторно"
  public isResendButtonDisabled = false;
  public resendCountdown = 0;
  private resendTimer: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private apiV2Service: ApiV2Service,
    private persistenceService: PersistenceService
  ) { }

  private startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.resendCountdown = 60;

    this.resendTimer = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) {
        this.isResendButtonDisabled = false;
        clearInterval(this.resendTimer);
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  }

  setMode(mode: 'pswd' | 'code') {
    this._mode = mode;
  }

  toBeginLogin() {
    this.isCodeRequested = false;
  }

  restore() {
    this.router.navigate(['/restore-password']);
  }

  public async redirectAfterLogin() {
    if (this.authService.isLoggedIn) {
      const userInfo = await this.authService.getUserInfo();

      if (isClubRole(userInfo)) {
        if (!this.persistenceService.checkSheduledRedirect()) {
          const ctx = await this.apiV2Service.context.get();
          const firstClub = ctx.clubs.find(x => x.cityId !== '00000000000000000000000000000000' && x.cityId !== '00000000-0000-0000-0000-000000000000');
          if (firstClub) {
            this.router.navigate([`/home`]);
          } else {
            this.authService.logout();
          }
        }
      } else {
        if (!this.persistenceService.checkSheduledRedirect()) {
          this.router.navigate([`/`]);
        }
      }
    }
  }

  login() {
    if (this.attemptToSend) { return; }
    this.form.form.markAllAsTouched();
    if (this.form.form.valid) {
      this.attemptToSend = true;
      this.authService.logIn({ emailOrPhone: this.user.name, password: this.user.pass })
      .then(() => {
        this.isSubmit = true;
        this.redirectAfterLogin();
      })
      .catch(() => {
        this.user.pass = '';
      })
      .finally(() => {
        this.attemptToSend = false;
      });
    }
  }

  public _beginEmailRegistration() {
    if (this.attemptToSend) return;
    this.form.form.markAllAsTouched();
    if (this.form.form.valid) {
      this.attemptToSend = true;
      this.authService.beginEmailRegistration(this.user.name)
        .then(({ authToken }) => {
          this.authToken = authToken;
          this.isCodeRequested = true;
          this.startResendCountdown();
        })
        .catch(() => {
          this.user.pass = '';
        })
        .finally(() => {
          this.attemptToSend = false;
        });
    }
  }

  public _completePhoneRegistration() {
    if (this.attemptToSend) return;
    this.form.form.markAllAsTouched();
    if (this.form.form.valid) {
      this.attemptToSend = true;
      this.authService.completeEmailRegistration(this.authToken, this.user.code)
        .then(() => {
          this.isSubmit = true;
          this.redirectAfterLogin();
        })
        .catch(() => {
          this.user.code = '';
        })
        .finally(() => {
          this.attemptToSend = false;
        });
    }
  }
}
